import { useState, useEffect } from 'react';

export const useMobileDetection = (breakpoint: number = 768) => {
  // 安全のため初期値をtrueに設定（モバイルファースト）
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, [breakpoint]);

  return isMobile;
};